import { ICON } from './icons';

export const CONTROL_MODE_CATEGORY = {
  HVAC: 'HVAC',
  HVAC_ZONE: 'HVAC_ZONE',
  BATTERY: 'BATTERY',
  EV: 'EV',
  OVERRIDE: 'OVERRIDE',
  EVENT: 'EVENT',
  STANDARD: 'STANDARD',
  UNKNOWN: 'UNKNOWN',
};

// TODO: Export new icon from Figma for unmanaged
export const CONTROL_MODE = {
  STANDARD: {
    key: 'Standard',
    label: 'Standard',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#666666',
    category: CONTROL_MODE_CATEGORY.STANDARD,
  },
  PRECONDITION: {
    key: 'Preconditioning',
    label: 'Preconditioning',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#B26789',
    category: CONTROL_MODE_CATEGORY.HVAC,
  },
  RELAX: {
    key: 'Relaxing',
    label: 'Relaxing',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#6788A8',
    category: CONTROL_MODE_CATEGORY.HVAC,
  },
  RAMPING_IN: {
    key: 'Ramping In',
    label: 'Ramping In',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#E69E38',
    category: CONTROL_MODE_CATEGORY.HVAC_ZONE,
  },
  RAMPING_OUT: {
    key: 'Ramping Out',
    label: 'Ramping Out',
    icon: ICON.CONTROL_MODE.ELEXITY,
    color: '#649591',
    category: CONTROL_MODE_CATEGORY.HVAC_ZONE,
  },
  EVENT: {
    key: 'Event',
    label: 'Event',
    icon: ICON.CONTROL_MODE.EVENT,
    category: CONTROL_MODE_CATEGORY.EVENT,
  },
  LOCAL_OVERRIDE: {
    key: 'Local Override',
    label: 'Local Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
    category: CONTROL_MODE_CATEGORY.OVERRIDE,
  },
  REMOTE_OVERRIDE: {
    key: 'Remote Override',
    label: 'Remote Override',
    icon: ICON.CONTROL_MODE.OVERRIDE,
    category: CONTROL_MODE_CATEGORY.OVERRIDE,
  },
  UNMANAGED: {
    key: 'Unmanaged',
    label: 'Unmanaged',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
  OFFLINE: {
    key: 'Offline',
    label: 'Offline',
    icon: ICON.ACTIVITY.OFFLINE,
  },
  DEFAULT: {
    key: 'Default',
    label: 'Default',
    icon: ICON.ACTIVITY.UNMANAGED,
  },
};
